import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Header from '../../Common/Header'
import Item from './Item'
import { createArr } from '@util'
import { DYNAMIC_PATH } from '@constant'
import More from '../../Common/More'

@observer
export default class extends Component {
  render() {
    let {
      data: { list },
      store: { totalAll }
    } = this.props
    list = list || []
    return (
      <>
        <Header
          title="商家动态"
          content={totalAll > 0 ? <span>共{totalAll}条动态</span> : '暂无动态'}
        />

        <div className="clearfix" style={{ marginBottom: 10 }}>
          {list.length > 0
            ? list.map(item => <Item key={item.id} {...item} />)
            : createArr(1).map(item => <Item key={item.id} mode="fake" />)}
        </div>

        {totalAll > list.length && (
          <More text="查看全部动态" link={DYNAMIC_PATH} />
        )}
      </>
    )
  }
}
